import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  FaCheese, 
  FaDrumstickBite, 
  FaBreadSlice, 
  FaCoffee, 
  FaBoxOpen, 
  FaCookie,
  FaCheck
} from 'react-icons/fa';
import './Products.css';

const Products = () => {
  const { t } = useTranslation();

  const categories = [
    {
      icon: <FaCheese />,
      title: t('products.categories.dairy.title'),
      description: t('products.categories.dairy.description'),
      color: '#ffc107'
    },
    {
      icon: <FaDrumstickBite />,
      title: t('products.categories.meat.title'),
      description: t('products.categories.meat.description'),
      color: '#f44336'
    },
    {
      icon: <FaBreadSlice />,
      title: t('products.categories.bakery.title'),
      description: t('products.categories.bakery.description'),
      color: '#ff9800'
    },
    {
      icon: <FaCoffee />,
      title: t('products.categories.beverages.title'),
      description: t('products.categories.beverages.description'),
      color: '#795548'
    },
    {
      icon: <FaBoxOpen />,
      title: t('products.categories.dry.title'),
      description: t('products.categories.dry.description'),
      color: '#9c27b0'
    },
    {
      icon: <FaCookie />,
      title: t('products.categories.snacks.title'),
      description: t('products.categories.snacks.description'),
      color: '#e91e63'
    }
  ];

  const services = [
    t('products.services.ordering'),
    t('products.services.delivery'),
    t('products.services.consulting'),
    t('products.services.quality')
  ];

  return (
    <div className="products-page">
      {/* Header Section */}
      <section className="products-header">
        <div className="products-header-overlay"></div>
        <div className="container">
          <h1>{t('products.title')}</h1>
          <p>{t('products.subtitle')}</p>
        </div>
      </section>

      {/* Categories Section */}
      <section className="products-categories">
        <div className="container">
          <div className="products-grid">
            {categories.map((category, index) => (
              <div className="product-card" key={index}>
                <div 
                  className="product-icon" 
                  style={{ background: `linear-gradient(135deg, ${category.color}, ${category.color}dd)` }}
                >
                  {category.icon}
                </div>
                <h3>{category.title}</h3>
                <p>{category.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="services-content">
            <div className="services-text">
              <h2>{t('products.services.title')}</h2>
              <div className="services-list">
                {services.map((service, index) => (
                  <div className="service-item" key={index}>
                    <FaCheck />
                    <span>{service}</span>
                  </div>
                ))}
              </div>
              <a 
                href="https://b2b.pasalebensmittel.de" 
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('nav.b2b')}
              </a>
            </div>
            <div className="services-image">
              <div className="service-badge badge-1">
                <FaCheck />
                <span>{t('products.badges.premiumQuality')}</span>
              </div>
              <div className="service-badge badge-2">
                <FaCheck />
                <span>{t('products.badges.fastDelivery')}</span>
              </div>
              <div className="service-badge badge-3">
                <FaCheck />
                <span>{t('products.badges.bestPrices')}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="products-cta">
        <div className="container">
          <div className="cta-box">
            <h2>{t('products.cta.title')}</h2>
            <p>{t('products.cta.description')}</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn btn-light">
                {t('hero.contact')}
              </a>
              <a 
                href="https://b2b.pasalebensmittel.de" 
                className="btn btn-outline-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('nav.b2b')}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;

